export default "__VITE_ASSET__ca42030a__"